/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';

import CustomButton from '~/components/layout/CustomButton';

export const Container = styled.div`
  padding: 70px;

  @media (max-width: 959px) {
    padding: 20px;
  }
`;

export const Title = styled.h1`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 37px;
  display: flex;
  align-items: center;
  color: #0b24fb;
`;

export const Text = styled.p`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 29px;
  color: #7a7a7a;
  max-width: 538px;
`;

export const ButtonsWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px !important;

  button {
    + button {
      margin-top: 16px;
    }
  }
`;

export const ButtonNext = styled(CustomButton)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const ButtonText = styled.p`  
  display: flex;
  justify-content: center;
  margin-right: 42px;
`;

export const ButtonBack = styled(CustomButton)`
  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const StepsInfoWrap = styled.div`
  font-family: 'Mangueira', sans-serif;
  display: flex;
  flex-direction: column;
  & + div {
    margin-top: 14px;
  }
`;

export const StepsInfoTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
  color: #7a7a7a;
`;

export const StepsInfoText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  line-height: 25px;
  color: #7a7a7a;
  max-width: 430px;
  margin-top: 9px;
`;

export const StepTextHighLight = styled.span`
  font-family: 'Mangueira', sans-serif;
  color: #0b24fb;
  margin: 0 4px;
`;
